"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasProfileWorkflow = void 0;
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasProfileWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
  constructor() {
    super();
    this.inputPin = [];
    this.outputPin = [Types_1.OutputPin.OUTPUT];
    this.type = Types_1.WorkflowType.PROFILE;
    this.settings = this.getDefaultSettings();
    this.customProcess = {};
    this.schema = validation_1.ProfileSchema;
  }
  getDefaultSettings() {
    return {
      profile_page_ids: [],
      register_after: new Date().toISOString(),
      next_workflow_ids: {
        next_workflow: null
      }
    };
  }
  setNextWorkflow(pin, next_workflow_id) {
    this.setDefaultNextWorkflow(pin, next_workflow_id);
  }
  getNextWorkflows() {
    const o = {};
    o[Types_1.OutputPin.OUTPUT] = this.getDefaultNextWorkflow();
    return o;
  }
  setCustomProcess(s, p) {}
  getProperties() {
    return [{
      attribute: 'profile_page_ids',
      datasource: 'ProfilePage',
      label: 'PROFILE',
      type: 'multiselect',
      mandatory: true,
      value: null
    }];
  }
}
exports.CanvasProfileWorkflow = CanvasProfileWorkflow;
